import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2c022d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { colspan: "10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "提单信息", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_form_item, {
        label: "提单类型",
        prop: "LadingBillType",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.ladingBillType), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "提单份数",
        prop: "LadingBillNumber",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.ladingBillNumber), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "备注",
        prop: "LadingBillRemark",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.form.Data.LadingBillRemark ?? "暂无数据"), 1)
        ]),
        _: 1
      })
    ])
  ]))
}